// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalStyles_modalContainer__OPPQq","modalMainBlk":"ModalStyles_modalMainBlk__+rgWB","disabled":"ModalStyles_disabled__3etVW"};